import RobertMorris from "../Assets/RobertMorris.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Card() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img
          className="card-img-style"
          src={RobertMorris}
          alt="judge picture"
        ></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Robert JT Morris</h2>
        <p className="card-sub-name-style">
          Chief Technology Strategist, MOHT
          <br />
          Executive Director, Singapore Medical Foundation AI Model (SIMFONI)
        </p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          className="close-button"
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />
            <h2>Robert JT Morris</h2>
            <h3>
              Chief Technology Strategist, MOHT
              <br />
              Executive Director, Singapore Medical Foundation AI Model
              (SIMFONI)
            </h3>

            <br />
            <p>
              Dr. Robert JT Morris is Chief Technology Strategist and Chief Data
              Officer for the Ministry of Health Transformation (MOHT) Singapore
              and concurrently Professor, National University of Singapore Yong
              Loo Lin School of Medicine. He is also Executive Director,
              Singapore Medical Foundation AI Model Programme (SIMFONI) and an
              Advisor to the National Research Foundation in the Prime
              Minister’s Office. His current focus is on application of computer
              and information sciences, including AI, to transform healthcare.{" "}
              <br />
              <br />
              From 2011-2017, he led all IBM Research’s Global Laboratories,
              including Australia, Africa, China, India, Japan, Singapore and
              South America. IBM Research earned 6 Nobel prizes, laying the
              basis for the information revolution. In 2010 Fortune and Money
              Magazine declared Robert the “Smartest Scientist in Technology” in
              their print magazines (V162, No. 1, July 26, 2010) and on the web
              https://fortune.com/2010/07/09/the-50-smartest-people-in-tech/.
              <br />
              <br />
              During 2006-2011, Robert was VP Services Research, IBM TJ Watson
              Research Center, NY, helping start IBM’s healthcare and IoT
              businesses, and earlier VP Assets Innovation, IBM Global Services.
              From 1999-2004, he was the VP & Director of IBM Almaden Research
              Center, Silicon Valley, where relational database technology, the
              disk drive, etc., were invented. Responsible for creation of
              Services Science, research for IBM’s ThinkPad, and Storage
              Systems. Earlier he led advanced systems research at TJ Watson
              Center, including the Deep Blue chess machine, which defeated
              world champion Garry Kasparov in 1997. Originally from Australia,
              he began his career at Bell Labs working on early neural networks
              and the largest packet switch of the era. He has lived in and
              worked from Asia since 2011.
              <br />
              <br />
              Robert was Chairman, Bay Area Science and Innovation Consortium
              (BASIC) 2001-2005, comprising heads of major research institutions
              in Silicon Valley. Published over 90 scientific articles, awarded
              14 patents. Editor IEEE Trans. on Computers and on many boards.
              Received the Australian-American Fulbright and Gowrie Fellowships,
              PICMET Leadership in Tech. Mgmt. Award, Fellow IEEE, IBM Acad. of
              Technology, Government University Industry Research Roundtable
              (National Academies).{" "}
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card;
